import { render } from "./OcDatesContent.vue?vue&type=template&id=60443f8c&scoped=true"
import script from "./OcDatesContent.vue?vue&type=script&lang=js"
export * from "./OcDatesContent.vue?vue&type=script&lang=js"

import "./OcDatesContent.vue?vue&type=style&index=0&id=60443f8c&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60443f8c"]])

export default __exports__